module.exports = __webpack_public_path__ + "static/media/Daniel Fidanque.afc0937c.jpg";